var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchInputIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.926 8.87409C15.9143 10.0469 15.6087 11.198 15.0371 12.2222C14.387 13.4101 13.4102 14.3869 12.2223 15.037C10.866 15.7654 9.30814 16.0284 7.7879 15.7856C6.26767 15.5429 4.86917 14.8077 3.80719 13.6932C2.7452 12.5786 2.07846 11.1463 1.90936 9.61609C1.74027 8.08591 2.07816 6.54253 2.87116 5.22299C3.66416 3.90344 4.8684 2.8807 6.29894 2.31184C7.72948 1.74298 9.3072 1.65946 10.7898 2.07411C12.2724 2.48875 13.5779 3.37863 14.5058 4.60708C15.4337 5.83553 15.9326 7.33461 15.926 8.87409Z",
    stroke: "#808080",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5705 17.5704C17.3887 17.7539 17.1723 17.8995 16.934 17.9988C16.6956 18.0982 16.4399 18.1493 16.1816 18.1493C15.9233 18.1493 15.6676 18.0982 15.4293 17.9988C15.1909 17.8995 14.9745 17.7539 14.7927 17.5704L12.2224 15.0371C13.4102 14.3869 14.387 13.4102 15.0372 12.2223L17.5705 14.763C17.7584 14.9453 17.9079 15.1635 18.0099 15.4046C18.1119 15.6458 18.1645 15.9049 18.1645 16.1667C18.1645 16.4286 18.1119 16.6877 18.0099 16.9288C17.9079 17.17 17.7584 17.3881 17.5705 17.5704V17.5704Z",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.46674 8.56297C5.46674 7.74178 5.79295 6.95423 6.37362 6.37356C6.95429 5.79289 7.74184 5.46667 8.56303 5.46667",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchInputIcon);
export default __webpack_public_path__ + "static/media/search-input-icon.a6ac7b27f536153d5d75da0417329927.svg";
export { ForwardRef as ReactComponent };